import { BaseWithId } from '@app/shared/models/base';
import { Address } from '@app/shared/models/address';
import { ActionListItem } from '@app/shared/components/action-list/action-list.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum ActivationState {
    ACTIVATED = 'ACTIVED',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATION_SCHEDULED = 'DEACTIVATION_SCHEDULED'
}

export class Department extends BaseWithId implements ActionListItem {
    public activation_state: ActivationState;
    public address: Address;
    public companyname: string;
    public creation_date: Date;
    public creation_username: string;
    public has_certificate_of_registration: boolean;
    public has_identity_card: boolean;
    public has_trade_licence: boolean;
    public active: boolean;
    public locked: boolean;
    public support_access_granted: boolean;

    get actionListDisplayName(): string {
        return this.companyname;
    }

    public trans = {
        companyname: marker('department.companyname')
    };

    constructor(json?) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            address: new Address(json && json.address),
            creation_date: json ? (json.creation_date ? new Date(json.creation_date) : (json.creationDate ? new Date(json.creationDate) : null)) : null,
            companyname: (json && (json.companyname || json.company_name || json.companyName || null)) || null,
            creation_username: json ? (json.creation_username ? json.creation_username : json.creationUsername) : null,
            has_certificate_of_registration: json ? (json.has_certificate_of_registration ? json.has_certificate_of_registration : json.hasCertificateOfRegistration) : null,
            has_identity_card: json ? (json.has_identity_card ? json.has_identity_card : json.hasIdentityCard) : null,
            has_trade_licence: json ? (json.has_trade_licence ? json.has_trade_licence : json.hasTradeLicence) : null,
            support_access_granted: json ? (json.support_access_granted ? json.support_access_granted : json.supportAccessGranted) : null
        });
    }
}
